import { useEffect, useRef } from "react"
import { useAppDispatch, useAppSelector } from "app/hooks"
import { getDailyWater } from "../waterSlice"
import { useFailed } from "features/notification/hooks"
import dayjs from "dayjs"
import { DATE_PARAM_FORMAT } from "config"
import { getTimeToRefreshOnNextDay } from "utils/dateTime"
import { useSearchParams } from "react-router-dom"

export const useDailyWater = () => {
  const dailyWaterTotal = useAppSelector((state) => state.water.dailyWaterTotal)
  const getDailyWaterLoading = useAppSelector(
    (state) => state.water.getDailyWaterLoading,
  )
  const getDailyWaterFailed = useAppSelector(
    (state) => state.water.getDailyWaterFailed,
  )

  const [searchParams] = useSearchParams()
  const date = searchParams.get("date") ?? dayjs().format(DATE_PARAM_FORMAT)

  const dispatch = useAppDispatch()
  const refreshOnNextDateTimeoutRef = useRef<ReturnType<
    typeof setTimeout
  > | null>(null)

  useEffect(() => {
    const fetchDailyWater = () => {
      dispatch(getDailyWater(date))
    }

    fetchDailyWater()

    const timeToRefresh = getTimeToRefreshOnNextDay()
    refreshOnNextDateTimeoutRef.current = setTimeout(() => {
      fetchDailyWater()
    }, timeToRefresh)

    return () => {
      if (refreshOnNextDateTimeoutRef.current) {
        clearTimeout(refreshOnNextDateTimeoutRef.current)
      }
    }
  }, [date, dispatch])

  useFailed(getDailyWaterFailed)

  return {
    dailyWaterTotal,
    getDailyWaterLoading,
  }
}
